import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export function IOSettingsInformation() {
  const { t } = useTranslation();

  const { values, errors, setFieldValue }: any = useFormikContext();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          as={TextField}
          name="year"
          error={errors.year}
          helperText={errors.year}
          fullWidth
          required
          label={t(translations.pages.ioSettings.year())}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl required fullWidth>
          <InputLabel>{t(translations.pages.ioSettings.semesterType())}</InputLabel>
          <Select
            fullWidth
            value={values.semesterType}
            onChange={e => setFieldValue('semesterType', e.target.value)}
            label={t(translations.pages.ioSettings.semesterType())}
          >
            <MenuItem key="Winter" value="Winter">
              Winter
            </MenuItem>
            <MenuItem key="Summer" value="Summer">
              Summer
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <DatePicker
          disablePast
          renderInput={props => (
            <TextField
              {...props}
              variant="outlined"
              required
              label={t(translations.pages.ioSettings.examRegistration())}
              fullWidth
            />
          )}
          inputFormat="dd.MM.yyyy"
          value={values.examRegistration ? values.examRegistration : null}
          onChange={e => setFieldValue('examRegistration', e)}
        />
      </Grid>
    </Grid>
  );
}
